/* global jQuery Swiper:false MktoForms2 */

/* change Marketo form submit button text */

(function ($, MktoForms2) {

	"use strict";

	MktoForms2.onFormRender(function () {
		setTimeout(function(){
			$(".mktoButtonWrap button[type=submit]").text("Submit");
		}, 10);
	});
}(jQuery, MktoForms2));

/* carousel */

(function () {

    "use strict";

	// PPT presernation slider

    var pptSlider = new Swiper(".presentation-slider", {
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true
		},
		navigation: {
			nextEl: ".ppt-next",
			prevEl: ".ppt-prev",
			disabledClass: "q-carousel-button--disabled"
		},
		pagination: false,
		centeredSlides: false
	});

	var pptContainer = document.querySelector(".presentation-slider");
	pptContainer.addEventListener("mouseenter", function () {
		pptSlider.autoplay.stop();
	});

	pptContainer.addEventListener("mouseleave", function () {
		pptSlider.autoplay.start();
	});
}());